module.exports = __webpack_public_path__ + "img/ico-caret-left-brand-color.2572f869.svg";